@let loadingState = $availableDashboards().state;
@if (loadingState === 'loading') {
<div content>
  <p i18n>Loading your dashboards, please wait.</p>
</div>
}
@else if (loadingState === 'error') {
<div content>
  <p i18n>Error loading your dashboards.</p>
</div>
}
@else if (loadingState === 'loaded') {
<div content>
  @if ($availableDashboards().dashboards.length > 1) {
  <div>
    <form>
    <mat-form-field appearance="outline">
      <mat-label>Select a dashboard</mat-label>
      <mat-select placeholder="Select a dashboard" [formControl]="selectDashboardControl">
        <mat-option *ngFor="let dashboard of $availableDashboards().dashboards" [value]="dashboard.id">
          {{ dashboard.doc.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    </form>
  </div>
  }
</div>
}

@if ($selectedDashboard().state === 'loaded') {
@let selectedDashboard = $selectedDashboard().dashboard;
<eas-board [boardJSON]="selectedDashboard.doc.board" [boardId]="$selectedDashboard().dashboard.doc._id"/>
}
